// @gnolang/tm2-js-client reaches for Node's Buffer inside getStatus() and
// friends. Browsers have no Buffer; without this the very first read fails
// with "ReferenceError: Buffer is not defined". Must be imported first.
import { Buffer } from 'buffer';
if (typeof globalThis.Buffer === 'undefined') globalThis.Buffer = Buffer;
